import { Spinner } from '@shopify/polaris'
import React, { useState } from 'react'
import ProductImage from './image/ProductImage'
import logger from '../../../../../../../../lib/logger'
import './style.scss'

function AddImage({ onChange, value, changeVariantId, closeModal }) {

  const [loaded, setLoaded] = useState(true)

  const onChangeImg = async (event) => {
    event.preventDefault()
    setLoaded(false)
    let reader = new FileReader()
    let file = event.target.files[0]

    // For GIF and WebP files, use direct base64 conversion to avoid processing issues
    if (file.type === 'image/gif' || file.type === 'image/webp') {
      reader.onloadend = () => {
        const base64Data = reader.result

        // Validate and clean the base64 data
        if (isValidBase64(base64Data)) {
          let img = new Image()
          img.onload = () => {
            setLoaded(true)
            const newImage = {
              status: 'create',
              src: base64Data,
              product_id: '',
              id: Date.now(),
              variant_ids: changeVariantId ? [changeVariantId] : [],
              position: Math.max(...[0, ...value.map(_i => _i.position)]) + 1,
            }
            onChange([ ...value, newImage ])
            if (changeVariantId && typeof closeModal == 'function') {
              closeModal()
            }
          }
          img.onerror = (e) => {
            logger.error(`Image upload: ${file.type} failed to load`, e)
            setLoaded(true)
          }
          img.src = base64Data
        } else {
          logger.error(`Image upload: invalid base64 for ${file.type}`)
          setLoaded(true)
        }
      }

      reader.onerror = (e) => {
        logger.error(`Image upload: FileReader failed for ${file.type}`, e)
        setLoaded(true)
      }

      reader.readAsDataURL(file)
      return
    }

    // Original processing for other image types (JPEG, PNG, etc.)
    const productImage = await new ProductImage(file).process()

    if (!productImage) {
      logger.error('Image upload: ImageParsing returned no result')
      setLoaded(true)
      return false
    }

    reader.onloadend = () => {
      let img = new Image()
      img.onload = () => {
        setLoaded(true)
        const newImage = {
          status: 'create',
          src: reader.result,
          product_id: '',
          id: Date.now(),
          variant_ids: changeVariantId ? [changeVariantId] : [],
          position: Math.max(...[0, ...value.map(_i => _i.position)]) + 1,
        }
        onChange([ ...value, newImage ])
        if (changeVariantId && typeof closeModal == 'function') {
          closeModal()
        }
      }
      img.onerror = (e) => {
        logger.error('Image upload: processed image failed to load', e)
        setLoaded(true)
      }
      img.src = reader.result
    }

    reader.onerror = (e) => {
      logger.error('Image upload: FileReader error for processed image', e)
      setLoaded(true)
    }

    reader.readAsDataURL(productImage)
  }

  // Base64 validation helper
  function isValidBase64(str) {
    if (!str || typeof str !== 'string') return false
    try {
      const parts = str.split(',')
      if (parts.length < 2) return false
      const base64Part = parts[1]
      if (!base64Part) return false
      // Test if we can encode/decode without errors
      const decoded = atob(base64Part)
      const reencoded = btoa(decoded)
      return reencoded === base64Part
    } catch (e) {
      logger.error('Image upload: base64 validation error', e.message)
      return false
    }
  }

  return (
    <div className="AddImage">
      <div className="photo-item">
        {!loaded && (
          <div>
            <Spinner />
            <div style={{ fontSize: '12px', marginTop: '5px' }}>Uploading...</div>
          </div>
        )}
        {loaded && (
          <label className="link">Add new
            <input
              style={{ display: 'none' }}
              type="file"
              onChange={onChangeImg}
              accept="image/*"
            />
          </label>
        )}
      </div>
    </div>
  )
}

export default AddImage
